var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.ss()}}},[_c('span',{class:[_vm.a==true?'b':'checkbox-button']}),_c('span',{class:[_vm.a==true?'checkbox-text':'']},[_vm._v("\n\t\tCheckbox\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }